module.exports = __webpack_public_path__ + "images/users/kaitori_focused_items/trading_cards/3_b930ad506616df600bf29cdb0a438db1.jpg";